import { Injectable, Output, EventEmitter } from '@angular/core'
import { SelectableLab } from '../masterdata/models/lab';

// Lab emitter service 
// Author: Naveen
@Injectable()
export class LabEmitterService {

  selectedLab: SelectableLab;

  @Output() change: EventEmitter<SelectableLab> = new EventEmitter();

  // On lab change, registers for call back method
  emitLab(lab:SelectableLab) {
    this.selectedLab = lab;
    this.change.emit(this.selectedLab);
  }

}